import { Ref, ref } from "vue";
import { DialogService } from "@/service/DialogService";
import { MstBukaService } from "@/service/MstBukaService";
import { BukaDetail, UpsertBukaRes } from "@/types/MstBuka";
import { useAuthStore } from "@/store/auth";
import { AxiosError } from "axios";
import { FormUtil } from "@/utils/FormUtil";
import { useForm } from "@/composable/form/form";

export function useBukaDetail() {
  const srv = new MstBukaService();
  const { removeAllError } = useForm()

  const bukaDetail: Ref<BukaDetail | null> = ref(null)

  const getBukaDetail = async (bukaId: number) => {
    bukaDetail.value = await srv.getBukaDetail(bukaId)
  }

  const initBukaDetail = async () => {
    const authStore = useAuthStore()
    bukaDetail.value = {
      mst_syozoku_id: authStore.user?.mst_syozoku_id ?? null,
      syozoku_code: null, // サーバー側ではクエリを投げる前に削るのでセット不要
      syozoku_name: null, // 同上
      mst_buka_id: null,
      buka_code: null,
      buka_name: null,
      buka_kana: null,
      syuugyou_basyos: []
    }
  }

  const upsertBukaDetail = async (bukaDetail: Ref<BukaDetail | null>) => {
    let res: UpsertBukaRes = {
      result: false,
      message: '',
      bukaId: null
    }

    if (!bukaDetail.value) return res

    DialogService.nowloading('登録中...')

    try {
      removeAllError(bukaDetail.value)
      res = await srv.upsertBukaDetail(bukaDetail.value)

      if (res.result) {
        await DialogService.info({
          html: res.message
        }, true)

      } else if (res.message) {
        await DialogService.error({
          html: res.message ?? '不明なエラーが発生しました'
        }, true)
      }
      return res
    } catch (e) {
      const err = e as AxiosError<any>
      FormUtil.setLaravelError(bukaDetail.value, err)
      return res
    }
  }


  const deleteBuka = async (bukaId: number) => {
    DialogService.nowloading('削除中...')

    try {
      const res = await srv.deleteBuka(bukaId)
      if (res.result) {
        await DialogService.info({
          html: '削除に成功しました。<br>再読込します。'
        }, true)
      } else if (res.message) {
        await DialogService.error({
          html: res.message ?? '不明なエラーが発生しました'
        }, true)
      }
      return true
    } catch (e) {
      return false
    }
  }


  return {
    bukaDetail,
    getBukaDetail,
    initBukaDetail,
    upsertBukaDetail,
    deleteBuka
  }
}
